import type { Database } from '../lib/adatbazis.ts';
import { TIPUS_CIMKE } from '../lib/tipusok.ts';
import { SZANDEK_CIMKE, type Szandek } from '../../../web/src/lib/cimkek.ts';
import { Kartya } from '../ui/elemek.tsx';
import { ingatlanAdatSorok } from './ingatlanAdatok.ts';

export type LeadSor = Database['public']['Tables']['leads']['Row'] & {
  terulet: { nev: string } | null;
  kollega: { nev: string; email: string } | null;
  iroda: { nev: string; slug: string } | null;
};

function Sor({ cimke, ertek }: { cimke: string; ertek: string }) {
  return (
    <div className="grid grid-cols-[minmax(0,1fr)] gap-0.5 py-2 sm:grid-cols-[minmax(0,2fr)_minmax(0,3fr)] sm:gap-3">
      <dt className="text-sm text-szoveg-halk">{cimke}</dt>
      <dd className="wrap-anywhere font-medium">{ertek}</dd>
    </div>
  );
}

export default function AdatokPanel({ lead }: { lead: LeadSor }) {
  const cim = [lead.iranyitoszam, lead.terulet?.nev, [lead.utca, lead.hazszam].filter(Boolean).join(' ')].filter(Boolean).join(', ');
  return (
    <Kartya>
      <h2 className="mb-1 text-[17px] font-medium tracking-[-0.015em]">Az ingatlan adatai</h2>
      <dl className="divide-y divide-vonal">
        <Sor cimke="Cím" ertek={cim} />
        <Sor cimke="Típus" ertek={TIPUS_CIMKE[lead.ingatlan_tipus]} />
        <Sor cimke="Eladási szándék" ertek={SZANDEK_CIMKE[lead.szandek as Szandek] ?? lead.szandek} />
        <Sor cimke="Már hirdeti?" ertek={lead.mar_hirdeti ? 'Igen' : 'Nem'} />
        {ingatlanAdatSorok(lead.ingatlan_tipus, lead.adatok).map((s) => <Sor key={s.kulcs} cimke={s.cimke} ertek={s.ertek} />)}
      </dl>
    </Kartya>
  );
}
